'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; /*
                                                                                                                                                                                                                                                                   * LOADERS
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Example data sources:
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   *  // Data sources must have a type, but they can also specify extra keys that will be passed to the endpoint
                                                                                                                                                                                                                                                                   *  // and model loaders.
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   *  dataSources = Map({
                                                                                                                                                                                                                                                                   *     balancers: { type: DATA_SOURCE_TYPE.ITEM, somethingExtra: "this is custom" },
                                                                                                                                                                                                                                                                   *     default_domain: { type: DATA_SOURCE_TYPE.COLLECTION, somethingExtra: "this is special" }
                                                                                                                                                                                                                                                                   *  })
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Example loader for webpack module loading:
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   *  function loadModel(modelName) {
                                                                                                                                                                                                                                                                   *    return (resolve, reject) => {
                                                                                                                                                                                                                                                                   *      require.ensure(
                                                                                                                                                                                                                                                                   *        [],
                                                                                                                                                                                                                                                                   *        (require) => resolve(require("./models/" + modelName)),
                                                                                                                                                                                                                                                                   *        (error) => reject(error)
                                                                                                                                                                                                                                                                   *      );
                                                                                                                                                                                                                                                                   *    }
                                                                                                                                                                                                                                                                   *  }
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   *  function myModelLoader({ dataSource, group, somethingExtra }) {
                                                                                                                                                                                                                                                                   *    // Do dispatch to determine which data source will use which loader
                                                                                                                                                                                                                                                                   *    if (dataSource == 'balancers') {
                                                                                                                                                                                                                                                                   *      return moduleLoader(loadModel('balancer'));
                                                                                                                                                                                                                                                                   *    } else if (dataSource === 'default_domain') {
                                                                                                                                                                                                                                                                   *      return moduleLoader(loadModel('domain'));
                                                                                                                                                                                                                                                                   *    } else {
                                                                                                                                                                                                                                                                   *      throw new Error(`Unknown loader for data source "${dataSource}"`)
                                                                                                                                                                                                                                                                   *    }
                                                                                                                                                                                                                                                                   *  }
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   *  let modelLoader = modelLoader(myModelLoader);
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   * Example endpoints:
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   *   const API_V1_PREFIX = '/api/v1';
                                                                                                                                                                                                                                                                   *
                                                                                                                                                                                                                                                                   *   const endpoints = Map({
                                                                                                                                                                                                                                                                   *     balancers: API_V1_PREFIX + '/balancers',
                                                                                                                                                                                                                                                                   *     default_domain: API_V1_PREFIX + '/domains/default'
                                                                                                                                                                                                                                                                   *   })
                                                                                                                                                                                                                                                                   */

exports.fetchReader = fetchReader;
exports.fetchData = fetchData;
exports.fetchWriter = fetchWriter;
exports.simpleCallbackModelLoader = simpleCallbackModelLoader;
exports.simplePromiseModelLoader = simplePromiseModelLoader;
exports.webpackOneDispatchLoader = webpackOneDispatchLoader;
exports.webpackPromiseDispatchLoader = webpackPromiseDispatchLoader;

var _immutable = require('immutable');

var _constants = require('./constants');

var _exceptions = require('./exceptions');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Simple no-op callback to use as a default for callbacks.
 */
//noinspection JSUnusedLocalSymbols
function NO_CALLBACK() {
  //noinspection JSConstructorReturnsPrimitive
  return undefined;
}

/*
 * Format a response from the server into data.
 */
//noinspection JSMethodCanBeStatic
function _formatResponse(response) {
  var contentType = response.headers.get('Content-Type', '< unknown >');
  if (!!contentType && contentType.indexOf('application/json') === 0) {
    return response.json();
  }

  // handle 401 and 403 response code, which currently has Content-Type text/html, but is expected to change soon.
  if (response.status === 401 || response.status === 403) {
    return response.text();
  }

  return response.text().then(function (text) {
    var message = 'Unknown content type from API with type "' + contentType + '": ' + text;
    return Promise.reject(message);
  });
}

/*
 * Locate the Last-Modified date from the headers
 */
function _getLastModified(headers) {
  var lastModified = headers.get('Last-Modified');
  if (!!lastModified) {
    return new Date(lastModified);
  } else {
    return undefined;
  }
}

/*
 * Locate the Last-Modified date from the headers
 */
function _getETag(headers) {
  var etag = headers.get('ETag');
  if (!!etag) {
    return etag;
  } else {
    return undefined;
  }
}

/*
 * Format the data returned from the server into an appropriate JS data structure.
 */
function _formatData(headers, data, many) {
  var contentType = headers.get('Content-Type', '< unknown >');

  if (contentType.indexOf('application/json') === 0) {
    if (many === true && data !== undefined) {
      // Unwrap data from object if this is a wrapped array
      data = data['data'];
    }
  } else {
    throw new _exceptions.LoaderContentTypeError('Unknown content type from API: ' + contentType);
  }

  // Set to a reasonable empty default.
  if (data === undefined) {
    if (many === true) {
      data = [];
    } else {
      data = {};
    }
  }
  return data;
}

/**
 * Reader factory function that uses fetch to look up data for the data loader by translating data sources
 * into API endpoints based on the `endpoints` argument.
 *
 * @param {function} getEndpoint - Mapping of dataSources to reader-dependent endpoints (e.g REST API endpoints).
 * @param {object} options - Additional options to use with this fetch loader
 */
function fetchReader(getEndpoint) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return function (dataSource, declaration, model) {
    var requestOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

    //noinspection UnnecessaryLocalVariableJS
    var _requestOptions$filte = requestOptions.filter,
        filter = _requestOptions$filte === undefined ? undefined : _requestOptions$filte,
        _requestOptions$sort = requestOptions.sort,
        sort = _requestOptions$sort === undefined ? undefined : _requestOptions$sort,
        _requestOptions$limit = requestOptions.limit,
        limit = _requestOptions$limit === undefined ? undefined : _requestOptions$limit,
        _requestOptions$only = requestOptions.only,
        only = _requestOptions$only === undefined ? undefined : _requestOptions$only,
        _requestOptions$group = requestOptions.group,
        group = _requestOptions$group === undefined ? undefined : _requestOptions$group;


    var requestUrl = getEndpoint(_extends({}, declaration, { dataSource: dataSource, group: group, filter: filter }));
    var requestQueryParams = [];
    if (filter !== undefined) {
      requestQueryParams.push(getFilterForUrl(filter));
    }
    if (sort !== undefined) {
      requestQueryParams.push(getSortForUrl(sort));
    }
    if (limit !== undefined) {
      requestQueryParams.push(getLimitForUrl(limit));
    }

    if (group !== undefined) {
      requestQueryParams.push(getGroupForUrl(group));
      if (only !== undefined) {
        requestQueryParams.push(getOnlyForUrl(only));
      }
    } else if (only !== undefined) {
      requestQueryParams.push(getOnlyForUrl(only));
    } else if (model.useOnly) {
      requestQueryParams.push(getOnlyForUrl(model.schema.keys));
    }

    if (requestQueryParams.length > 0) {
      var joiner = requestUrl.indexOf('?') !== -1 ? '&' : '?';
      requestUrl += joiner + requestQueryParams.join('&');
    }
    var many = declaration['type'] === _constants.DATA_SOURCE_TYPES.COLLECTION;
    return fetchData(requestUrl, many, options, requestOptions);
  };
}

function getFilterForUrl(filter) {
  return 'q=' + filter;
}

function getSortForUrl(sort) {
  if (_immutable.Set.isSet(sort) || _immutable.List.isList(sort) || Array.isArray(sort)) {
    return 'sort=' + sort.join('+');
  } else {
    return 'sort=' + sort;
  }
}

function getOnlyForUrl(only) {
  if (_immutable.Set.isSet(only) || _immutable.List.isList(only) || Array.isArray(only)) {
    return 'only=' + only.join('+');
  } else {
    return 'only=' + only;
  }
}

function getLimitForUrl(limit) {
  if (limit === 'all') {
    return 'page_size=all';
  } else {
    return 'limit=' + limit;
  }
}

function getGroupForUrl(group) {
  return group;
}

function fetchData(requestUrl, many) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var requestOptions = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};

  // Allow caller to use an alternate fetch-compatible function (default to global fetch)
  var _options$fetchCb = options.fetchCb,
      fetchCb = _options$fetchCb === undefined ? fetch : _options$fetchCb;

  //noinspection UnnecessaryLocalVariableJS

  var _requestOptions$getAu = requestOptions.getAuthenticationHeaders,
      getAuthenticationHeaders = _requestOptions$getAu === undefined ? function () {
    return Promise.resolve({});
  } : _requestOptions$getAu,
      _requestOptions$onReq = requestOptions.onRequest,
      onRequest = _requestOptions$onReq === undefined ? NO_CALLBACK : _requestOptions$onReq,
      _requestOptions$onRec = requestOptions.onReceive,
      onReceive = _requestOptions$onRec === undefined ? NO_CALLBACK : _requestOptions$onRec,
      _requestOptions$onRec2 = requestOptions.onReceiveUnchanged,
      onReceiveUnchanged = _requestOptions$onRec2 === undefined ? NO_CALLBACK : _requestOptions$onRec2,
      _requestOptions$onRec3 = requestOptions.onReceiveUnauthenticated,
      onReceiveUnauthenticated = _requestOptions$onRec3 === undefined ? NO_CALLBACK : _requestOptions$onRec3,
      _requestOptions$onRec4 = requestOptions.onReceiveUnauthorized,
      onReceiveUnauthorized = _requestOptions$onRec4 === undefined ? NO_CALLBACK : _requestOptions$onRec4,
      _requestOptions$onErr = requestOptions.onError,
      onError = _requestOptions$onErr === undefined ? NO_CALLBACK : _requestOptions$onErr;


  onRequest();

  return getAuthenticationHeaders().then(function (authenticationHeaders) {
    try {
      var _requestOptions = {};
      _requestOptions['headers'] = authenticationHeaders;

      var genericErrorCallback = function genericErrorCallback(error) {
        onError(error);
        return Promise.resolve(error);
      };

      // Initiate the fetch Promise
      return fetchCb(requestUrl, _requestOptions).then(function (response) {
        return _formatResponse(response).then(function (data) {
          if (response.ok) {
            var etag = _getETag(response.headers);
            var lastModified = _getLastModified(response.headers);
            data = _formatData(response.headers, data, many);
            onReceive(data, lastModified, etag);
            return Promise.resolve(data);
          } else if (response.status === 304) {
            data = _formatData(response.headers, data, false);
            onReceiveUnchanged(data);
            return Promise.resolve(data);
          } else if (response.status === 401) {
            onReceiveUnauthenticated(data);
            return Promise.resolve(data);
          } else if (response.status === 403) {
            onReceiveUnauthorized(data);
            return Promise.resolve(data);
          } else {
            data = _formatData(response.headers, data, false);
            onError(data);
            return Promise.resolve(data);
          }
        }, genericErrorCallback);
      }, genericErrorCallback);
    } catch (error) {
      onError(error);
      return Promise.reject(error);
    }
  }, function (error) {
    onReceiveUnauthenticated(error);
    return Promise.resolve(error);
  });
}

function _formatWriteData(headers, changes, data) {
  // TODO: Merge server returned data into changes for reconciliation with state.
  return data;
}

/**
 * Writer factory function that uses fetch to submit data updates for the data loader by translating data sources
 * with the `getEndpoint` argument.
 *
 * @param {function} getEndpoint - Mapping of dataSources to reader-dependent getEndpoint (e.g REST API getEndpoint).
 * @param {object} options - Additional options to use with this fetch loader
 */
function fetchWriter(getEndpoint) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};


  // Allow caller to use an alternate fetch-compatible function (default to global fetch)
  var _options$fetchCb2 = options.fetchCb,
      fetchCb = _options$fetchCb2 === undefined ? fetch : _options$fetchCb2;


  return function (dataSource, declaration, model, saveItems) {
    var requestOptions = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {};

    //noinspection UnnecessaryLocalVariableJS
    var _requestOptions$filte2 = requestOptions.filter,
        filter = _requestOptions$filte2 === undefined ? undefined : _requestOptions$filte2,
        _requestOptions$group2 = requestOptions.group,
        group = _requestOptions$group2 === undefined ? undefined : _requestOptions$group2,
        _requestOptions$getAu2 = requestOptions.getAuthenticationHeaders,
        getAuthenticationHeaders = _requestOptions$getAu2 === undefined ? function () {
      return Promise.resolve({});
    } : _requestOptions$getAu2,
        _requestOptions$onReq2 = requestOptions.onRequest,
        onRequest = _requestOptions$onReq2 === undefined ? NO_CALLBACK : _requestOptions$onReq2,
        _requestOptions$onRec5 = requestOptions.onReceive,
        onReceive = _requestOptions$onRec5 === undefined ? NO_CALLBACK : _requestOptions$onRec5,
        _requestOptions$onRec6 = requestOptions.onReceiveUnauthenticated,
        onReceiveUnauthenticated = _requestOptions$onRec6 === undefined ? NO_CALLBACK : _requestOptions$onRec6,
        _requestOptions$onRec7 = requestOptions.onReceiveUnauthorized,
        onReceiveUnauthorized = _requestOptions$onRec7 === undefined ? NO_CALLBACK : _requestOptions$onRec7,
        _requestOptions$onErr2 = requestOptions.onError,
        onError = _requestOptions$onErr2 === undefined ? NO_CALLBACK : _requestOptions$onErr2;


    return getAuthenticationHeaders().then(function (authenticationHeaders) {
      var request = void 0;
      var requests = [];

      // Loop all items and trigger the request action first to ensure that all state is reasonably protected from future
      // writes.  There still exists a race condition between when the saveItems are generated and here.
      saveItems.forEach(function (item) {
        var id = item.id,
            action = item.action,
            changes = item.changes;

        try {
          onRequest(id, action, changes);
        } catch (error) {
          onError(id, action, changes, error);
          requests.push(Promise.reject(error));
        }
      });

      // Create all fetch promises
      saveItems.forEach(function (item) {
        var id = item.id,
            api_id = item.api_id,
            action = item.action,
            changes = item.changes;

        try {
          // Build the request URL and add any filter criteria (if required)
          var requestUrl = getEndpoint(_extends({}, declaration, { dataSource: dataSource, group: group, filter: filter }));
          if (api_id && (action === _constants.WRITE_STYLE.UPDATE || action === _constants.WRITE_STYLE.DELETE)) {
            requestUrl = requestUrl + '/' + api_id;
          }

          var method = _constants.WRITE_STYLE_HTTP[action];
          var saveRequestOptions = {
            method: method
          };

          var requestHeaders = authenticationHeaders;

          // Add the JSON body for creation and updating of records
          if (action === _constants.WRITE_STYLE.CREATE || action === _constants.WRITE_STYLE.UPDATE) {
            requestHeaders["Content-Type"] = "application/json";
            saveRequestOptions['body'] = JSON.stringify(changes);
          }

          // Add the headers
          saveRequestOptions['headers'] = requestHeaders;

          var genericErrorCallback = function genericErrorCallback(error) {
            onError(id, action, changes, error);
            return Promise.resolve(error);
          };

          // Initiate the fetch Promise
          request = fetchCb(requestUrl, saveRequestOptions).then(function (response) {
            var formatted = _formatResponse(response);
            return formatted.then(function (data) {
              if (response.ok) {
                data = _formatWriteData(response.headers, changes, data);
                onReceive(id, action, changes, data);
                return Promise.resolve(data);
              } else if (response.status === 401) {
                onReceiveUnauthenticated(data);
                return Promise.resolve(data);
              } else if (response.status === 403) {
                onReceiveUnauthorized(id, action, changes, data);
                return Promise.resolve(data);
              } else {
                var error = response.statusText + ': ' + JSON.stringify(data);
                onError(id, action, changes, error);
                return Promise.resolve(error);
              }
            }, genericErrorCallback);
          }, genericErrorCallback);

          requests.push(request);
        } catch (error) {
          onError(id, action, changes, error);
          requests.push(Promise.reject(error));
        }
      });

      return Promise.all(requests);
    }, function (error) {
      onReceiveUnauthenticated(error);
      return Promise.resolve(error);
    });
  };
}

/*
 * EXAMPLE Model Loader
 *
 * TODO: Remove when better tests are in place for src/module.js
 */
function exampleModelLoader(dataSource, declaration) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var _options$getAuthentic = options.getAuthenticationHeaders,
      getAuthenticationHeaders = _options$getAuthentic === undefined ? function () {
    return Promise.resolve({});
  } : _options$getAuthentic,
      _options$onRequest = options.onRequest,
      onRequest = _options$onRequest === undefined ? function () {
    return undefined;
  } : _options$onRequest,
      _options$onReceive = options.onReceive,
      onReceive = _options$onReceive === undefined ? function (model) {
    return undefined;
  } : _options$onReceive,
      _options$onReceiveUnc = options.onReceiveUnchanged,
      onReceiveUnchanged = _options$onReceiveUnc === undefined ? function (data) {
    return undefined;
  } : _options$onReceiveUnc,
      _options$onReceiveUna = options.onReceiveUnauthenticated,
      onReceiveUnauthenticated = _options$onReceiveUna === undefined ? function (data) {
    return undefined;
  } : _options$onReceiveUna,
      _options$onReceiveUna2 = options.onReceiveUnauthorized,
      onReceiveUnauthorized = _options$onReceiveUna2 === undefined ? function (data) {
    return undefined;
  } : _options$onReceiveUna2,
      _options$onError = options.onError,
      onError = _options$onError === undefined ? function (error) {
    return undefined;
  } : _options$onError,
      _options$group = options.group,
      group = _options$group === undefined ? undefined : _options$group;


  try {
    onRequest();
    var MyModel = function (_ModelBase) {
      _inherits(MyModel, _ModelBase);

      function MyModel() {
        _classCallCheck(this, MyModel);

        return _possibleConstructorReturn(this, (MyModel.__proto__ || Object.getPrototypeOf(MyModel)).apply(this, arguments));
      }

      return MyModel;
    }(ModelBase);
    onReceive(MyModel);
  } catch (error) {
    onError(error);
  }
}

/*
 * EXAMPLE Model Loader factory that uses arguments
 *
 * TODO: Remove when better tests are in place for src/module.js
 */
function exampleModelLoaderFactory(arg1, arg2) {
  return function (dataSource, declaration) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$getAuthentic2 = options.getAuthenticationHeaders,
        getAuthenticationHeaders = _options$getAuthentic2 === undefined ? function () {
      return Promise.resolve({});
    } : _options$getAuthentic2,
        _options$onRequest2 = options.onRequest,
        onRequest = _options$onRequest2 === undefined ? function () {
      return undefined;
    } : _options$onRequest2,
        _options$onReceive2 = options.onReceive,
        onReceive = _options$onReceive2 === undefined ? function (model) {
      return undefined;
    } : _options$onReceive2,
        _options$onReceiveUnc2 = options.onReceiveUnchanged,
        onReceiveUnchanged = _options$onReceiveUnc2 === undefined ? function (data) {
      return undefined;
    } : _options$onReceiveUnc2,
        _options$onReceiveUna3 = options.onReceiveUnauthenticated,
        onReceiveUnauthenticated = _options$onReceiveUna3 === undefined ? function (data) {
      return undefined;
    } : _options$onReceiveUna3,
        _options$onReceiveUna4 = options.onReceiveUnauthorized,
        onReceiveUnauthorized = _options$onReceiveUna4 === undefined ? function (data) {
      return undefined;
    } : _options$onReceiveUna4,
        _options$onError2 = options.onError,
        onError = _options$onError2 === undefined ? function (error) {
      return undefined;
    } : _options$onError2,
        _options$group2 = options.group,
        group = _options$group2 === undefined ? undefined : _options$group2;


    var one = arg1; // Do something with arg1
    var two = arg2; // So something with arg2

    try {
      onRequest();
      var MyModel = function (_ModelBase2) {
        _inherits(MyModel, _ModelBase2);

        function MyModel() {
          _classCallCheck(this, MyModel);

          return _possibleConstructorReturn(this, (MyModel.__proto__ || Object.getPrototypeOf(MyModel)).apply(this, arguments));
        }

        return MyModel;
      }(ModelBase);
      onReceive(MyModel);
    } catch (error) {
      onError(error);
    }
  };
}

/*
   Simple callback-based model loader

   Loader that will accept a dispatcher that returns a model loader with the signature:

      function modelLoader(onSuccess, onError) {
         if ( itWorks ) {
            onSuccess(model);
         } else {oik,
            onError(error);
         }
      }

     onSuccess takes a single argument, the model class
     onError takes a single argument, the error to be returned to the state
 */
function simpleCallbackModelLoader(getModelCallback) {
  return function (dataSource, declarations) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$onRequest3 = options.onRequest,
        onRequest = _options$onRequest3 === undefined ? NO_CALLBACK : _options$onRequest3,
        _options$onReceive3 = options.onReceive,
        onReceive = _options$onReceive3 === undefined ? NO_CALLBACK : _options$onReceive3,
        _options$onError3 = options.onError,
        onError = _options$onError3 === undefined ? NO_CALLBACK : _options$onError3;


    try {
      var modelCallback = getModelCallback(dataSource, declarations, options);
      onRequest();
      modelCallback(onReceive, onError);
    } catch (error) {
      onError(error);
    }
  };
}

/*
   Simple promise-based model loader

   Loader that will accept a dispatcher that returns a model loader with the signature:

      function modelLoaderPromise() {
        if ( itWorks ) {
          return Promise.resolve(model);
        } else {
          return Promise.reject(error);
        }
      }

     Success in the promise should return the model class
     Errors in the promise should return the error state
 */
function simplePromiseModelLoader(getModelPromise) {
  return function (dataSource, declarations) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _options$onRequest4 = options.onRequest,
        onRequest = _options$onRequest4 === undefined ? NO_CALLBACK : _options$onRequest4,
        _options$onReceive4 = options.onReceive,
        onReceive = _options$onReceive4 === undefined ? NO_CALLBACK : _options$onReceive4,
        _options$onError4 = options.onError,
        onError = _options$onError4 === undefined ? NO_CALLBACK : _options$onError4;


    try {
      var modelPromise = getModelPromise(dataSource, declarations, options);
      onRequest();
      modelPromise.then(function (model) {
        onReceive(model);
      }, function (error) {
        onError(error);
      });
    } catch (error) {
      onError(error);
    }
  };
}

/*
  Generic WebPack 1 Javascript Module Model Loader (Using callbacks)

  Load a model class from a file bundled with the WebPack module system.

  To use, pass a module callback (loadModule) that loads a Javascript module out of the /models/ sub-directory.  The
  Javascript module should contain a single "export default class" that extends `ModelBase`.

    // Requires webpack plugin for error argument.
    // See: https://github.com/richardscarrott/require-error-handler-webpack-plugin
    function loadModel(modelName) {
      return (onSuccess, onError) => {
        require.ensure(
          [],
          require => { onSuccess(require("./models/" + modelName)) },
          error => { onError(error) },
          "chunkName"
        );
      };
    }

    let dataSources = Map({
      gadgets: { type: DATA_SOURCE_TYPE.COLLECTION },
      widgets: { type: DATA_SOURCE_TYPE.COLLECTION },

      default_widget: { type: DATA_SOURCE_TYPE.ITEM }
    })

    let modelLoaders = Map({
      gadgets: loadModel('gadget'),        // Loads ./models/gadget.js
      widgets: loadModel('widget'),        // Loads ./models/widget.js

      default_widget: loadModel('widget')  // Loads ./models/widget.js
    })

    let loader = webpackOneDispatchLoader(modelLoaders);

    let apiReducer = new Api('api', dataSources, loader, ... )
 */
function webpackOneDispatchLoader(dataSourceMap) {
  return simpleCallbackModelLoader(function (dataSource) {
    return dataSourceMap.get(dataSource);
  });
}

/*
  Generic WebPack Javascript Module Model Loader (Using Promises)

  Load a model class from a file bundled with the WebPack module system.

  To use, pass a module callback (loadModule) that loads a Javascript module out of the /models/ sub-directory.  The
  Javascript module should contain a single "export default class" that extends `ModelBase`.

    function loadModel(modelName) {
      return () => require.ensure(
            [],
            require => resolve(require("./models/" + modelName)),
            "chunkName"
        );
      });
    }

    let dataSources = Map({
      gadgets: { type: DATA_SOURCE_TYPE.COLLECTION },
      widgets: { type: DATA_SOURCE_TYPE.COLLECTION },

      default_widget: { type: DATA_SOURCE_TYPE.ITEM }
    })

    let modelLoaders = Map({
      gadgets: loadModel('gadget'),        // Loads ./models/gadget.js
      widgets: loadModel('widget'),        // Loads ./models/widget.js

      default_widget: loadModel('widget')  // Loads ./models/widget.js
    })

    let loader = webpackPromiseDispatchLoader(modelLoaders);

    let apiReducer = new Api('api', dataSources, loader, ... )
 */
function webpackPromiseDispatchLoader(dataSourceMap) {
  return simplePromiseModelLoader(function (dataSource) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var promiseFactory = dataSourceMap.get(dataSource);
    return promiseFactory.apply(undefined, [dataSource].concat(args));
  });
}